import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './styles';
import DisplayBlock from '../../../components/DisplayBlock';

export default function AuthLayout({ children }) {
  return (
    <>
      <Wrapper>
        <DisplayBlock />
        <div>{children}</div>
      </Wrapper>
    </>
  );
}

AuthLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
